import { useState } from "react";

const viewSizeConfig = {
  small: {
    container: {
      p: 1,
      borderRadius: 2,
      backgroundColor: "#181A20",
      color: "#F5F7FA",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 2,
      minHeight: 48,
      width: "100%",
      borderBottom: "1px solid #23263b",
      position: "relative",
      boxShadow: "none",
      "&:hover": { backgroundColor: "#23263b" },
    },
    image: {
      width: 32,
      height: 32,
      borderRadius: 2,
      objectFit: "cover",
      background: "#222",
      flexShrink: 0,
      mr: 1,
    },
    fileName: {
      color: "#F5F7FA",
      fontWeight: 500,
      fontSize: 16,
      flexGrow: 1,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    menuButton: {
      color: "#aaa",
      padding: 0,
      ml: 1,
    },
  },
  medium: {
    container: {
      p: 2,
      borderRadius: 3,
      backgroundColor: "#191C23",
      color: "#F5F7FA",
      boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column", // <--- KEY: vertical layout!
      alignItems: "stretch",
      position: "relative",
      height: 190, // <--- make all cards the same height!
      minWidth: 0,
      transition: "background 0.3s, box-shadow 0.3s",
      "&:hover": {
        backgroundColor: "#23263b",
        boxShadow: "0 6px 24px rgba(0,0,0,0.36)",
      },
    },
    topBar: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1,
    },
    fileName: {
      color: "#F5F7FA",
      fontWeight: 600,
      fontSize: "1rem",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      flex: 1,
      mr: 1,
    },
    image: {
      width: "100%",
      height: 110,
      objectFit: "cover",
      borderRadius: 6,
      background: "#222",
      flexGrow: 1,
    },
    menuButton: {
      color: "#aaa",
      p: 0.5,
      ml: 1,
    },
  },
  medium: {
    container: {
      p: 2,
      borderRadius: 3,
      backgroundColor: "#191C23",
      color: "#F5F7FA",
      boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column", // <--- KEY: vertical layout!
      alignItems: "stretch",
      position: "relative",
      height: 190, // <--- make all cards the same height!
      minWidth: 0,
      transition: "background 0.3s, box-shadow 0.3s",
      "&:hover": {
        backgroundColor: "#23263b",
        boxShadow: "0 6px 24px rgba(0,0,0,0.36)",
      },
    },
    topBar: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1,
    },
    fileName: {
      color: "#F5F7FA",
      fontWeight: 600,
      fontSize: "1rem",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      flex: 1,
      mr: 1,
    },
    image: {
      width: "100%",
      height: 110,
      objectFit: "cover",
      borderRadius: 6,
      background: "#222",
      flexGrow: 1,
    },
    menuButton: {
      color: "#aaa",
      p: 0.5,
      ml: 1,
    },
  },
  large: {
    container: {
      p: 2.5,
      borderRadius: 4,
      backgroundColor: "#191C23",
      color: "#F5F7FA",
      boxShadow: "0 2px 8px rgba(0,0,0,0.20)",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      position: "relative",
      height: 260, // Taller card for large view!
      minWidth: 0,
      transition: "background 0.3s, box-shadow 0.3s",
      "&:hover": {
        backgroundColor: "#23263b",
        boxShadow: "0 8px 32px rgba(0,0,0,0.34)",
      },
    },
    topBar: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 1.5,
    },
    fileName: {
      color: "#F5F7FA",
      fontWeight: 700,
      fontSize: "1.09rem",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      flex: 1,
      mr: 1,
    },
    image: {
      width: "100%",
      height: 170, // Even bigger for a prominent preview
      objectFit: "cover",
      borderRadius: 8,
      background: "#222",
      flexGrow: 1,
    },
    menuButton: {
      color: "#aaa",
      p: 0.6,
      ml: 1,
    },
  },
};

export default function useViewSize(viewSize = "medium") {
  const getGridSizes = () => {
    switch (viewSize) {
      case "small":
        return { xs: 12 };
      case "medium":
        return { xs: 12, sm: 6, md: 4, lg: 2, xl: 2 }; // 6 per row at lg+
      case "large":
        return { xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }; // 12/3 = 4 per row
      default:
        return { xs: 12, sm: 6, md: 4, lg: 3 };
    }
  };

  const getStyleConfig = () => {
    return viewSizeConfig[viewSize] || viewSizeConfig.medium;
  };

  return { getGridSizes, getStyleConfig };
}
